'use strict';
'use client';
import { j as e } from "../../external/react/jsx-runtime.js";
import { useState as p } from "react";
import { useToast as V } from "../Toast/index.js";
import { FontAwesomeIcon as r } from "../../external/@fortawesome/react-fontawesome/index.es.js";
import { faImage as x, faEllipsis as A, faCheckCircle as B } from "../../external/@fortawesome/pro-solid-svg-icons/index.js";
import N from "../../external/classnames/index.js";
function Q({
  onUpload: v,
  onSuccess: t,
  onError: l,
  isUploading: f = !1,
  maxSizeInMB: u = 10,
  acceptedTypes: h = ["image/*"],
  disabled: g = !1,
  className: C,
  children: U,
  uploadComplete: w,
  previewUrl: k,
  hasError: T
}) {
  const [i, j] = p(null), [z, n] = p(!1), [P, o] = p(!1), { showToast: c } = V(), R = w ?? z, y = k ?? i, F = T ?? P, L = () => {
    switch (!0) {
      case g:
        return "disabled";
      case F:
        return "error";
      case f:
        return "uploading";
      case (R && !!y):
        return "complete";
      default:
        return "default";
    }
  }, I = (a) => N("flex h-32 cursor-pointer flex-col justify-center rounded-2xl p-4", {
    default: "border-grey-200 border-2 border-dashed text-grey-400",
    uploading: "border-grey-200 border-2 border-dashed text-grey-400",
    complete: "border-grey-200 border-2 text-grey-400",
    error: "border-red-error border-2 border-dashed text-red-error bg-red-error/5",
    disabled: "border-grey-100 border-2 border-dashed text-grey-200 cursor-not-allowed bg-grey-50"
  }[a]), M = async (a) => {
    var d;
    const s = (d = a.target.files) == null ? void 0 : d[0];
    if (s) {
      if (!h.some((m) => m === "image/*" ? s.type.startsWith("image/") : s.type === m)) {
        c({
          variant: "error",
          title: "Invalid file type",
          message: "Please select a valid file type"
        });
        return;
      }
      const H = u * 1024 * 1024;
      if (s.size > H) {
        c({
          variant: "error",
          title: "File too large",
          message: `File is too large. Maximum size is ${u}MB`
        });
        return;
      }
      o(!1), n(!1), i && URL.revokeObjectURL(i);
      const O = URL.createObjectURL(s);
      j(O);
      try {
        await v(s), n(!0), o(!1), t == null || t();
      } catch {
        j(null), n(!1), o(!0), l == null || l(), c({
          variant: "error",
          title: "Upload failed",
          message: "There was an error uploading your file. Please try again."
        });
      }
    }
  }, b = L(), E = () => ({
    error: /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col items-center justify-center space-y-3", children: [
      /* @__PURE__ */ e.jsx(
        r,
        {
          icon: x,
          className: "text-red-error",
          size: "3x"
        }
      ),
      /* @__PURE__ */ e.jsx("span", { className: "text-center text-red-error", children: "Upload failed. Click to try again." })
    ] }),
    disabled: /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col items-center justify-center space-y-3", children: [
      /* @__PURE__ */ e.jsx(
        r,
        {
          icon: x,
          className: "text-grey-200",
          size: "3x"
        }
      ),
      /* @__PURE__ */ e.jsx("span", { className: "text-center text-grey-200", children: "Upload is disabled" })
    ] }),
    uploading: /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col items-center justify-center space-y-3", children: [
      /* @__PURE__ */ e.jsx(
        r,
        {
          icon: A,
          className: "text-grey-300 h-12 w-12"
        }
      ),
      /* @__PURE__ */ e.jsx("span", { className: "text-center", children: "Uploading..." })
    ] }),
    complete: /* @__PURE__ */ e.jsxs("div", { className: "text-green-faint-dark inline-flex space-x-4", children: [
      /* @__PURE__ */ e.jsx(
        "img",
        {
          src: y || "",
          alt: "Uploaded",
          className: "h-24 w-24 rounded-lg object-cover"
        }
      ),
      /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col items-center justify-center space-y-2", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "text-green-success", children: [
          "Upload Complete",
          /* @__PURE__ */ e.jsx(
            r,
            {
              icon: B,
              className: "pl-2"
            }
          )
        ] }),
        /* @__PURE__ */ e.jsxs("span", { children: [
          /* @__PURE__ */ e.jsx("span", { className: "md:hidden", children: "Tap the image to upload a new one" }),
          /* @__PURE__ */ e.jsx("span", { className: "hidden md:inline", children: "Click the image to upload a new one" })
        ] })
      ] })
    ] }),
    default: /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col items-center justify-center space-y-3", children: [
      /* @__PURE__ */ e.jsx(
        r,
        {
          icon: x,
          className: "text-grey-300",
          size: "3x"
        }
      ),
      /* @__PURE__ */ e.jsxs("span", { className: "text-center", children: [
        /* @__PURE__ */ e.jsx("span", { className: "md:hidden", children: "Tap to upload an image from your device" }),
        /* @__PURE__ */ e.jsx("span", { className: "hidden md:inline", children: "Click to upload an image from your device" })
      ] })
    ] })
  })[b];
  return /* @__PURE__ */ e.jsxs("div", { className: N("w-full", C), children: [
    /* @__PURE__ */ e.jsxs("label", { className: I(b), children: [
      /* @__PURE__ */ e.jsx(
        "input",
        {
          type: "file",
          accept: h.join(","),
          className: "hidden",
          capture: "user",
          onChange: M,
          disabled: g || f
        }
      ),
      E()
    ] }),
    U
  ] });
}
export {
  Q as PhotoUpload,
  Q as default
};
